import script from "./text-file-list.vue?vue&type=script&lang=tsx"
export * from "./text-file-list.vue?vue&type=script&lang=tsx"

import "./text-file-list.vue?vue&type=style&index=0&id=6a66a36b&lang=scss&scoped=true"

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a66a36b"]])

export default __exports__